import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { Container, Spinner} from "react-bootstrap";
import { showToast } from '../../../components/common/notification/Notification';
import { FaArrowLeft } from "react-icons/fa";
import PromotionDetailCard from "./PromotionDetailCard";
import SaaSNotFoundState from "../../../components/common/saas/SaaSNotFoundState";

const PromoSingle = ({backbtn, ownerId: setOwnerId}) => {
  const { Id } = useParams();
  const [promotionData, setPromotionData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isError, setIsError] = useState(false);
  const loggedInUser = useSelector((state) => state.auth.user);
  const token =
    loggedInUser?.accessToken ||
    loggedInUser?.token ||
    loggedInUser?.refreshToken;
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const assetUrl = process.env.REACT_APP_ASSET_URL;

  const [mediaData, setMediaData] = useState({
    images: [],
    promotion_videos: [],
    attachments: [],
  });

  useEffect(() => {
    fetchPromotionItem();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Id]);

  const fetchPromotionItem = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${baseUrl}/promotion/${Id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      ); 
      console.log(response.data.promotion)

      if (response.status === 200) {
        const promotion = response.data.promotion;
        if (setOwnerId && promotion.user) {
          setOwnerId(promotion.user.id); 
        }
        // First update the main data
        setPromotionData({
          images: promotion.propertyImages || [],
          video: promotion.promotion_videos || [],
          attachements: promotion.attachements || [],
          description: promotion.project_description || '',
          title: promotion.project_name || '',
          creater: [promotion.partner.first_name, promotion.partner.last_name].filter(Boolean).join(" "),
          cost: promotion.starting_cost || '',
          type: promotion.property_type.name || '',
          city: promotion.city_name || '',
          state: promotion.state_name || '',
          pin_code: promotion.pin_code || '',
          photo: promotion.partner.first_name || [],
          createdOn: promotion.created_on || '',
        });

        // Now use raw response directly to update media
        setMediaData({
          images: (promotion.propertyImages || []).map((img) => ({
            url: assetUrl + img.image_url,
            // url: `${assetUrl}${img.image_url}`, 
          })),
          promotion_videos: (promotion.promotion_videos || []).map((video) => ({
            url: assetUrl + video.url_path,
          })),
          attachments: (promotion.attachements || []).map((attachment) => ({
            url: assetUrl + attachment.attachment_url,
          })),
        });
      }  
 
      
      else {
        showToast('Failed to fetch data', { type: 'error' });
      }
    } catch (error) {
      setIsError(true);
      console.error('Fetch error:', error);
      showToast('Error fetching data', { type: 'error' }); 
    } finally {
      setIsLoading(false);
    }
  };


  if (isLoading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
      </Container>
    );
  }

  if (isError || !promotionData || !promotionData.title) {
    return (
      <SaaSNotFoundState
        title="Promotion not found"
        description="This promotional offer or campaign is no longer available."
        backLink={backbtn || "/customer/promotions"}
        backLabel="Back to Promotions"
      />
    );
  }
 

  const cleanBack = backbtn ? backbtn.replace(/\/+$/, "") : "";
  const discussionPath = cleanBack && Id ? `${cleanBack}/${Id}/discussion` : null;

  return (
    <div className="container-fluid px-0 mb-3" style={{ maxWidth: "1200px" }}>
      <PromotionDetailCard
        images={mediaData.images}
        videos={mediaData.promotion_videos}
        attachments={mediaData.attachments}
        title={promotionData.title}
        description={promotionData.description}
        cost={promotionData.cost}
        type={promotionData.type}
        state={promotionData.state}
        city={promotionData.city}
        pin_code={promotionData.pin_code}
        photo={promotionData.photo}
        creater={promotionData.creater}
        createdOn={promotionData.createdOn}
        backBtn={backbtn}
        discussionPath={discussionPath}
      />
    </div> 
  );
}
export default PromoSingle;